const _ = require('lodash');

module.exports = function (shopLocatorService, $state) {
    return {
        restrict: 'E',
        scope: {
            selectedKey: '=ngModel'
        },
        link(scope) {
        scope.isloading = false;
        scope.state = null;
        scope.radio = { value: null };
        scope.states = ['ACT', 'NSW', 'QLD', 'SA', 'VIC', 'TAS', 'WA', 'NT'];

        scope.getStoreByState = function (state) {

            // update URL
            $state.go('shop.allstores.state', { state });

            scope.isloading = true;
            scope.state = state;
            const noOfStores = 500;
            shopLocatorService.getStoresByState(state, noOfStores).then(function (response) {
                scope.stores = response.Stores;
                scope.storesCount = response.Stores.length;
                scope.isloading = false;

                _.forEach(scope.stores, function (store) {
                    store.storeUrl = scope.generateUrl(store);
                });
            });
        };

        scope.generateUrl = function (store) {
            return shopLocatorService.generateUrlParamsForStoreInfos(store);
        };

        const initialize = function () {

            // get the $state params if defined
            scope.selectedState = $state.params.state ? $state.params.state.toUpperCase() : scope.states[1];
            scope.radio.value = scope.selectedState;

            scope.getStoreByState(scope.selectedState);
        };

        initialize();

    },
    template: require('./shop-list-filter-template.html').trim()
};
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/allstores/shop-list-filter-directive.js
 **/